/**
 * Renderiza o corpo estático de marketing (conteúdo aprovado no protótipo).
 * Usado apenas para páginas institucionais sem interação — formulários e
 * comportamentos vivem em componentes React próprios.
 */
export function StaticBody({ html }: { html: string }) {
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
}
